import { HubConnectionBuilder, LogLevel } from "@aspnet/signalr";
export default {
  install(Vue) {

    const connection = new HubConnectionBuilder()
      .withUrl(`${Vue.prototype.$http.defaults.baseURL}/message-hub`) 
      .configureLogging(LogLevel.Information)
      .build();


    const messageHub = new Vue();

    Vue.prototype.$messageHub = messageHub;

    connection.on("SendVoteChange", (entityId, entityType, votes) => {
        if(entityType == 'SipChallenge'){
            messageHub.$emit("ChallengeVoteChange", { entityId, votes });
        }
        else if(entityType == 'SipIdea'){
            messageHub.$emit("IdeaVoteChange", { entityId, votes });
        }
    });

    connection.on("SendUpdatedNotice", (entityId, entityType, userId) => {
      messageHub.$emit("UpdatedNotice", { entityId, entityType, userId });
  });

    // if connection closed, reopen it
    let startedPromise = null;
    function start() {
      startedPromise = connection.start().catch(() => {
        return new Promise((resolve, reject) =>
          setTimeout(
            () =>
              start()
                .then(resolve)
                .catch(reject),
            5000
          )
        );
      });
      return startedPromise;
    }

    connection.onclose(() => start());

    start();
  }
};